import { InjectionToken } from '@angular/core';

// Looks up the JSON-LD for a URL. Provided only in AppServerModule: the structured data is written into the
// server-rendered HTML, and keeping seo-schema.ts (which imports every page index) out of the browser bundle
// keeps those indexes out of the first download.
export const PAGE_SCHEMA = new InjectionToken<(url: string) => any[]>('PAGE_SCHEMA');

const SITE_URL = 'https://www.atmavaan.com';

// Small builders for pages that set their own JSON-LD from the component (same output as seo-schema.ts).
export function webPageSchema(type: string, path: string, name: string, description: string) {
  return {
    '@context': 'https://schema.org',
    '@type': type,
    'url': SITE_URL + path,
    'name': name,
    'description': description,
    'isPartOf': { '@id': SITE_URL + '/#website' },
    'publisher': { '@id': SITE_URL + '/#organization' }
  };
}

// crumbs: [name, path] pairs after Home
export function breadcrumbSchema(crumbs: [string, string][]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [['Home', '/'], ...crumbs].map(([name, path], i) => ({
      '@type': 'ListItem', 'position': i + 1, 'name': name, 'item': SITE_URL + path
    }))
  };
}

export function faqPageSchema(faqs: { q: string; a: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': faqs.map(({ q, a }) => ({ '@type': 'Question', 'name': q, 'acceptedAnswer': { '@type': 'Answer', 'text': a } }))
  };
}
